'use client';

import { Transition } from '@headlessui/react';
import type { ReactNode } from 'react';

interface StaggerItemProps {
  show: boolean;
  delayMs: number;
  className?: string;
  style?: React.CSSProperties;
  children: ReactNode;
}

export const StaggerItem = ({ show, delayMs, className, style, children }: StaggerItemProps) => {
  return (
    <Transition
      show={show}
      appear
      enter={`transition-all duration-300 ease-out [transition-delay:${delayMs}ms]`}
      enterFrom="opacity-0 translate-y-2"
      enterTo="opacity-100 translate-y-0"
      leave="transition-all duration-300 ease-out"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-2"
    >
      <div className={className} style={style}>{children}</div>
    </Transition>
  );
};

export default StaggerItem;